class ClientsDelegate {
    setRows(rows) {
        this.setState((prevState) => {
            return {
                rows,
            };
        });
    }

    setOpen(open) {
        this.setState((prevState) => {
            return {
                open,
            };
        });
    }

    setClient(client) {
        this.setState((prevState) => {
            return {
                client,
            };
        });
    }
}

export default ClientsDelegate;
